import { useMutation } from "@apollo/client";
import { SEND_QUERY_REQUEST } from "../Mutations/SendQueryRequest";
import { determineVehicleQuery } from "../utils/utils";
import { Fab, Tooltip } from "@material-ui/core";
import { checkPermission } from "../utils/Roles";

const fabButtonStyle = disabled => {
  return {
    color: "white",
    backgroundColor: disabled ? "grey" : "#5fa06a",
    fontWeight: "bolder",
    fontSize: "1rem",
    margin: "0 0.5rem",
    minWidth: "2vw",
    minHeight: "2vw",
    maxWidth: "4vw",
    maxHeight: "4vw",
    cursor: disabled ? "not-allowed" : "pointer",
  };
};

//TODO: the plate only query must include the license plate type.
//If this field can't be found, show the user an error message so they can fix the vehicle detail.
const TwentyEightButton = ({
  vehicle,
  user,
  incidentId,
  vinOnly,
  plateOnly,
  setPopper,
  tokenDisabled = true,
  incidentOriId,
}) => {
  // const personIsBlank = !person?.personalAttribute?.lastName
  // const disabled = personIsBlank || person?.personalAttribute?.organization
  let disabled = false;

  if (vinOnly) {
    disabled = !vehicle?.vehicleVin?.name;
  }

  if (plateOnly) {
    disabled = !vehicle?.vehiclePlate?.name;
  }

  if (!disabled) {
    disabled = !checkPermission(
      user?.roleNames,
      "add_query_returns",
      user?.editableOriIds,
      incidentOriId,
      incidentId
    );
  }

  if (incidentId && !disabled) {
    disabled = !checkPermission(
      user?.roleNames,
      "edit_incident",
      user?.editableOriIds,
      incidentOriId,
      incidentId
    );
  }

  disabled = disabled || tokenDisabled;

  const [sendQueryRequest] = useMutation(SEND_QUERY_REQUEST, {
    onCompleted: data => {
      if (data) {
        const res = data[Object.keys(data)[0]];
        if (res.message) {
          // alert(res.message)
          setPopper &&
            setPopper({
              open: true,
              content: res.message,
              severity: "success",
            });
        } else {
          const errorMessage = res.errors.join(" ");
          // alert(errorMessage)
          setPopper &&
            setPopper({ open: true, content: errorMessage, severity: "error" });
        }
      }
    },
    onError: err => {
      // alert(err)
      setPopper &&
        setPopper({ open: true, content: err?.message, severity: "error" });
    },
  });

  const validForm = input => {
    let message = "";
    if (!input.ORI || !input.DAC || !input.USR || !input.PWD) {
      message =
        message +
        " Your machine is not properly authorized to perform Query Returns. Please contact your agency Program Manager for assistance.\n";
    }
    if (!input.ORI) {
      message = message.concat("\n\u2022The Sub-ORI field is required.");
    }
    if (!input.DAC) {
      message = message.concat("\n\u2022The Device ID field is required.");
    }
    if (!input.USR) {
      message = message.concat("\n\u2022The User Name field is required.");
    }
    if (!input.PWD) {
      message = message.concat("\n\u2022The Password field is required.");
    }

    if (message) {
      alert(message);
      return false;
    } else {
      return true;
    }
  };

  const handleQuery = e => {
    e.preventDefault();
    let queryInfo = determineVehicleQuery(vehicle, vinOnly, plateOnly);
    if (queryInfo?.errors?.length > 0) {
      alert(queryInfo.errors.join("\n"));
      delete queryInfo.errors;
      return;
    }

    if (queryInfo?.errors) delete queryInfo.errors;

    let input = Object.assign(
      {
        originatorId: user?.id,
        incidentId: incidentId,
        ORI: user?.officer?.deptAttribute?.nletsOri || "",
        DAC: user?.officer?.deptAttribute?.nletsDevId?.toString() || "",
        USR: user?.officer?.deptAttribute?.nletsLogin || "",
        PWD: user?.officer?.deptAttribute?.nletsPassword || "",
      },
      queryInfo
    );
    if (validForm(input)) {
      sendQueryRequest({
        variables: { input: input },
        context: { serializationKey: "incidentQueue" },
      });
    } else {
      return null;
    }
  };

  return (
    <Tooltip
      title={
        disabled
          ? tokenDisabled
            ? "Switch access is currently blocked due to the SoftToken requirement being disabled."
            : "You don't have permissions to run this query"
          : "28 Query"
      }
    >
      <span style={{ cursor: disabled ? "not-allowed" : "pointer" }}>
        <Fab
          onClick={handleQuery}
          data-cy={"vehicle-28-button-" + vehicle?.id}
          style={fabButtonStyle(disabled)}
          disabled={disabled}
          // onClick={(e) => handleQuery(e, person)}
        >
          28
        </Fab>
      </span>
    </Tooltip>
  );
};

export default TwentyEightButton;
